
export const ChangeLogsActions = [
    {label: "Update", value: "update"},
    {label: "Create", value: "create"}
];
